export default {
  id: "id",
  type: "type",
  adderId: "adder_id",
  question: "question",
  createdAt: "created_at",
  adderName: "admins.name",
};
